import { render, staticRenderFns } from "./DodEmployeesList.vue?vue&type=template&id=bb865bb2&scoped=true&"
import script from "./DodEmployeesList.vue?vue&type=script&lang=js&"
export * from "./DodEmployeesList.vue?vue&type=script&lang=js&"
import style0 from "./DodEmployeesList.vue?vue&type=style&index=0&id=bb865bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb865bb2",
  null
  
)

export default component.exports